import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';

@Injectable({providedIn: 'root'})
export class NlrFieldRecordAttachmentsModalDataService {
    private attachmentsData = new BehaviorSubject<any>([]);

    updateAttachments(extensions: any, prefix: string, attachments: any, checkPdfSignature: boolean, maxSize: number, index: number) {
        const inputData = {
            extensions: extensions,
            prefix: prefix,
            attachments: attachments,
            checkPdfSignature: checkPdfSignature,
            maxSize: maxSize,
            index: index
        };
        this.attachmentsData.next(inputData);
    }

    updateAttachment(index: number, obj: any) {
        const updatedAttachments = this.attachmentsData.getValue().attachments.map((v, i) => {
            return i === index ? {...v, fileName: obj.fileName, fileSize: obj.fileSize, url: obj.url, uuid: obj.uuid} : v;
        });
        const inputData = {...this.attachmentsData.getValue(), attachments: updatedAttachments};
        this.attachmentsData.next(inputData);
    }

    getAttachmentsData(): Observable<any> {
        return this.attachmentsData;
    }
}
